import axios, { AxiosError } from "axios";
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-App-Internal'] = true;
// setting for injecting no logging (see MIX_APP_LOG .env)
axios.defaults.headers.common['X-No-Log'] = !process.env.MIX_APP_LOG;
export { axios, AxiosError };
